/* global BigInt */

const MONEY_FIELDS = {
  without_vat: 'without_vat_minor',
  with_vat: 'with_vat_minor',
  vat: 'vat_minor'
};

function parseMinorUnitString(value) {
  // The Admin reporting contract deliberately sends exact base-10 strings.
  // Reject numbers, including unsafe ones, because their precision may already
  // have been lost before this presentation layer receives them.
  if (typeof value !== 'string' || !/^-?\d+$/.test(value)) {
    return null;
  }

  return BigInt(value);
}

function groupInteger(integerPart, locale) {
  const separator = locale === 'ro' ? '.' : ',';
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export function formatMinorUnits(money, basis = 'without_vat', locale = 'ro') {
  const field = MONEY_FIELDS[basis] || MONEY_FIELDS.without_vat;
  const rawValue = money && money[field];

  const parsedMinor = parseMinorUnitString(rawValue);
  if (parsedMinor === null) {
    return '—';
  }

  const minor = parsedMinor;
  const negative = minor < 0n;
  const absolute = negative ? -minor : minor;
  const major = absolute / 100n;
  const decimals = String(absolute % 100n).padStart(2, '0');
  const decimalSeparator = locale === 'ro' ? ',' : '.';
  const currency = money.currency || 'RON';

  return `${negative ? '-' : ''}${groupInteger(String(major), locale)}${decimalSeparator}${decimals} ${currency}`;
}

export function formatQuantity(value, locale = 'ro') {
  const integer = quantityIntegerValue(value);
  if (integer === null) {
    return '—';
  }

  const source = String(integer);
  const negative = source.startsWith('-');
  const absolute = negative ? source.slice(1) : source;
  return `${negative ? '-' : ''}${groupInteger(absolute, locale)}`;
}

export function quantityIntegerValue(value) {
  if (typeof value === 'bigint') {
    return value;
  }
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) ? BigInt(value) : null;
  }
  if (typeof value !== 'string' || !/^(?:0|-?[1-9]\d*)$/.test(value)) {
    return null;
  }
  return BigInt(value);
}

export function formatPercent(value, locale = 'ro') {
  if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
    return '—';
  }

  return `${new Intl.NumberFormat(locale === 'ro' ? 'ro-RO' : 'en-US', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0
  }).format(Number(value))}%`;
}

export function moneyMinorValue(money, basis = 'without_vat') {
  const field = MONEY_FIELDS[basis] || MONEY_FIELDS.without_vat;
  const value = money && money[field];
  const parsedMinor = parseMinorUnitString(value);
  return parsedMinor === null ? 0n : parsedMinor;
}
